import React, { FunctionComponent } from 'react';
import Layout from '../../components/molecules/Layout';
import { AboutRecord } from '../../types/dato.types';
import { getAboutPage } from 'src/lib/dato';

import ReactMarkdown from 'react-markdown';
import { SinglePageHeader, SinglePageContent } from 'src/components/molecules/SinglePage';

interface Props {
  about: AboutRecord;
}

const PageAbout: FunctionComponent<Props> = ({ about }) => {
  return (
    <Layout>
      <SinglePageHeader title={about?.title} imageUrl={about?.headerImage?.url} />
      <SinglePageContent>
        <ReactMarkdown source={about?.description} />
      </SinglePageContent>
    </Layout>
  );
};

export async function getStaticProps() {
  const about = await getAboutPage();
  return {
    props: { about },
  };
}

export default PageAbout;
